import {
    useAcceptIntakeSuggestion,
    useDismissIntakeSuggestion,
    useIntakeProfile,
    useSaveIntakeProfile,
} from "../../application/useIntakeProfile";
import IntakeProfileCard from "./IntakeProfileCard";

/** The intake profile of one of the therapist's patients, read and decided on in place. */
export default function PatientIntakeProfile({
    patientId,
    ageFromBirthDate,
}: {
    patientId: string;
    ageFromBirthDate?: number | null;
}) {
    const profile = useIntakeProfile(patientId);
    const save = useSaveIntakeProfile(patientId);
    const accept = useAcceptIntakeSuggestion(patientId);
    const dismiss = useDismissIntakeSuggestion(patientId);

    return (
        <IntakeProfileCard
            data={profile.data}
            isLoading={profile.loading}
            isError={profile.failed}
            onRetry={profile.retry}
            onSave={(values) => save.mutateAsync(values)}
            isSaving={save.isPending}
            onAccept={(suggestionId, value) => accept.mutateAsync({ suggestionId, value })}
            onDismiss={(suggestionId) => dismiss.mutateAsync(suggestionId)}
            ageFromBirthDate={ageFromBirthDate}
        />
    );
}
